export const tourLock = {
  dashboard: false,
  tools: false,
};
